module.exports = __webpack_public_path__ + "static/media/fly0218.83a695a4.webp";